import React, { lazy, Suspense } from 'react'
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom'
import config from 'config'
import { ChatProvider } from 'components/ChatWidget'
// The flow's ground and nav while its code loads, so it never opens on a blank page.
import StartLoading from 'flows/start/ui/StartLoading'

// Signup and group activation load independently and share the flow design components.
const StartFlow = lazy(() => import(/* webpackChunkName: "start" */ 'flows/start'))
const GroupFlow = lazy(() => import(/* webpackChunkName: "start" */ 'flows/activation'))
// Every other page: kept out of /start's first load. The guides, the opt-out and the comparison are
// drawn on /start's frame too, so their ground and nav show while they load.
const LegacyRoutes = lazy(() => import('./LegacyRoutes'))

const RedirectToStart = () => {
  const { search } = useLocation()
  return <Navigate to={{ pathname: '/start', search }} replace />
}

export const RedirectToHomePage = () => {
  window.location = config.HOMEPAGE_URL
  return null
}

const Router = () => (
  <BrowserRouter>
    <ChatProvider>
      <Routes>
        <Route index element={<RedirectToHomePage />} />
        <Route path="join" element={<RedirectToStart />} />
        <Route path="join-now" element={<RedirectToStart />} />
        <Route path="book-and-join" element={<RedirectToStart />} />
        <Route
          path="start/*"
          element={<Suspense fallback={<StartLoading />}><StartFlow /></Suspense>}
        />
        <Route path="activate/:slug/:step?" element={<Suspense fallback={<StartLoading />}><GroupFlow /></Suspense>} />
        <Route path="*" element={<Suspense fallback={<StartLoading />}><LegacyRoutes /></Suspense>} />
      </Routes>
    </ChatProvider>
  </BrowserRouter>
)

export default Router
